import React, { useState, useEffect, useContext } from 'react'
import { useParams } from 'react-router-dom'
import { LangContext } from '../../../context/lang-context'
import { NavigationContext } from '../../../context/navigation-context'
import useFetch from '../../../hooks/fetchMSSQL-hook'
import ReturnLink from '../../../components/Return/ReturnLink'
import MachineInfo from '../../../components/Machine/MachineInfo'
import MachineProducts from '../../../components/Machine/MachineProducts'
import MachineRecipes from '../../../components/Machine/MachineRecipes'
import MachinesImages from '../../../components/Machine/MachinesImages'
import NewMachine from './NewMachine/NewMachine'
import MachineTask from './CommandCaller/MachineTask'
import MachineLogs from './MachineLogs'
import { IndexedDbContext } from '../../../db/indexedDbProvider'
import MachineVI from './MachineVI/MachineVI'
import CopyMachineConfiguration from "../../../components/Machine/CopyMachineConfiguration"


const isEnabledFlag = (value) => {
    const normalizedValue = String(value === null || value === undefined ? '' : value).trim().toLowerCase()

    return value === true || value === 1 || normalizedValue === '1' || normalizedValue === 'true'
}

const FullMachine = () => {
    const { machineId } = useParams()
    const { fetchMssqlApi } = useFetch()
    const { setHeaderData } = useContext(NavigationContext)
    const { TRL_Pack } = useContext(LangContext)
    const { machinesIndexedDB, IndexedDBAsyncContext } = useContext(IndexedDbContext)
    const [showCopyModal, setShowCopyModal] = useState(false)
    const [machineData, setMachineData] = useState(null)
    const [param, setParam] = useState(machineId)
    const getMachineItemsType = () => {
        param !== '0' && fetchMssqlApi(`machine/${machineId}`, {}, (machineData) => {setMachineData({ ...machineData })}, () => {},
        () => IndexedDBAsyncContext.getItem('machines', machineId).then((data) => setMachineData(data)))
    }
    const [type, setType] = useState( !sessionStorage.getItem("isMobile") ? 0 : 4)
    useEffect(() => {
        switch (type) {
            case 0:
                setHeaderData({ text:  TRL_Pack.machine.header})
                break;
            case 1:
                setHeaderData({ text:  "Ustawienia R24 VMC"})
                break;
            case 2:
                setHeaderData({ text:  "Ustawienia zaawansowane R24 VMC"})
                break;
            case 3:
                setHeaderData({ text:  "Historia zmian stanów automatu"})
                break;
            case 4:
                setHeaderData({ text:  "Wizyta"})
                break;
            default:
                setHeaderData({ text:  TRL_Pack.machine.header})
        }
    }, [type])
    useEffect(() => {
        setHeaderData({ text: TRL_Pack.machine.header })
        getMachineItemsType()
    }, [])
    useEffect(() => {
        getMachineItemsType()
    }, [param])

    const checkMachineType = (machineType) =>
        !!machineType?.split(/[^A-Za-z0-9]/g)
            .filter((el) =>
                ['V10', 'V11', 'V12', 'V13', 'V14'].includes(
                    String(el).toUpperCase()
                )
            ).length

    const maintenanceIsSnack = isEnabledFlag(
        machineData?.IsSnack ??
        machineData?.MaintenanceIsSnack ??
        machineData?.MaintenanceTypeIsSnack
    )

    const maintenanceIsCoffee = isEnabledFlag(
        machineData?.IsCoffee ??
        machineData?.MaintenanceIsCoffee ??
        machineData?.MaintenanceTypeIsCoffee
    )

    return machineId !== '0' ? (
        <div>
            <div style={{ maxWidth: '100vw', scrollbarWidth: "0px" }} className='container-fluid'>
                <ul
                    className="nav nav-tabs machine-tabs mb-3 overflow-scroll flex-nowrap p-0"
                    style={{ scrollbarWidth: 0, "overflowY": "hidden" }}
                >
                    { 
                        !sessionStorage.getItem('isMobile') && (
                            <>
                                <li className="nav-item">
                                    <button
                                        className={`nav-link btn ${type === 0 && 'active'}`}
                                        onClick={() => type !== 0 && setType(0)}
                                        tabIndex="0"
                                    >
                                        Automat
                                    </button>
                                </li>
                                {navigator.onLine && (
                                    <>
                                        {machineData &&
                                            checkMachineType(machineData.MachineTypeName) && (
                                                <>
                                                    <li className="nav-item">
                                                        <button
                                                            className={`nav-link btn ${
                                                                type === 1 && 'active'
                                                            }`}
                                                            onClick={() => type !== 1 && setType(1)}
                                                            tabIndex="0"
                                                        >
                                                            Ustawienia R24 VMC
                                                        </button>
                                                    </li>
                                                    <li className="nav-item">
                                                        <button
                                                            className={`nav-link btn ${
                                                                type === 2 && 'active'
                                                            }`}
                                                            onClick={() => type !== 2 && setType(2)}
                                                            tabIndex="0"
                                                        >
                                                            Ustawienia zaawansowane R24 VMC
                                                        </button>
                                                    </li>
                                                </>
                                            )}
                                        <li className="nav-item">
                                            <button
                                                className={`nav-link btn ${type === 3 && 'active'}`}
                                                onClick={() => type !== 3 && setType(3)}
                                                tabIndex="0"
                                            >
                                                Historia zmian
                                            </button>
                                        </li>
                                    </>
                                )}
                            </>
                        )
                    }
                    {
                        sessionStorage.getItem("isMobile") && (
                            <li className="nav-item">
                                <button
                                    className={`nav-link btn ${type === 4 && 'active'}`}
                                    onClick={() => type !== 4 && setType(4)}
                                    tabIndex="0"
                                >
                                    Wizyta
                                </button>
                            </li>
                        )
                    }

                </ul>
                
            </div>
            {type === 0 && (
                <>
                    <div>
                        <ReturnLink path="/machines" />
                        {machineData && (
                            <>
                                <MachineInfo
                                    machineData={machineData}
                                    machineId={machineData.MachineId}
                                    updateMachine={setMachineData}
                                    data={machineData}
                                />
                                {maintenanceIsSnack ? (
                                <MachineProducts
                                    machineId={machineId}
                                    enableConfigurationModal={() => setShowCopyModal(true)}

                                />
                                ) : (
                                maintenanceIsCoffee && (
                                    <MachineRecipes machineId={machineId} />
                                )
                                )}
                            </>
                        )}
                    </div>
                </>
            )}
            {type === 1 && machineData && (
                <MachinesImages machineData={machineData} />
            )}
            {type === 2 && machineData && (
                <MachineTask machineData={machineData} />
            )}
            {type === 3 && machineData && (
                <MachineLogs machineData={machineData} />
            )}
            {type === 4 && machineData && <MachineVI machineData={machineData}/>}
            {showCopyModal && (
                <CopyMachineConfiguration
                    refMachineId={machineId}
                    handleClose={() => setShowCopyModal(false)}
                />
            )}
        </div>
    ) : (
        <>
            <NewMachine setParam={setParam} />
        </>
    )
}

export default FullMachine